module.exports = __webpack_public_path__ + "media/laws-bg2@3x.ad111fa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/laws-bg2@3x.jpg
// module id = 1349
// module chunks = 57